module.exports = __webpack_public_path__ + "static/media/emoji.d754277c.svg";